module.exports = __webpack_public_path__ + "img/camper_exteriour_1.c9a1b831.jpg";